import { ECartType, EItemGroup, IEcommerceProduct } from '@services/ecommerceService';
import { getPriceWithoutVat } from '@utils/math';
import { isProductAvailable } from '@utils/product';

import { IDiscoveryBox, IDiscoveryBoxItem } from '../../model';

export const createEcommerceDiscoveryBox = (product: IDiscoveryBox): IEcommerceProduct => ({
  productId: product.productId,
  productCode: product.productCode,
  productName: product.name ?? '',
  vat: product.vat,
  brandName: product.brandName ?? '',
  price: Math.round((getPriceWithoutVat(product.priceWithVat, product.vat) + Number.EPSILON) * 100) / 100,
  fullPrice: product.priceWithVat,
  quantity: product.count,
  variantName: '',
  stockAvailability: true,
  group: EItemGroup.SERVICE,
  cartType: ECartType.Cart,
  primaryCategories: {
    kind: '',
    category: '',
    subCategory: '',
    type: '',
  },
  annotation: '',
  additionalVariantInfo: '',
});

export const createEcommerceDiscoveryBoxProduct = (product: IDiscoveryBoxItem): IEcommerceProduct => ({
  productId: product.productId,
  productCode: product.productCode,
  productName: product.name,
  vat: product.vat,
  brandName: product.brandName,
  price: Math.round((getPriceWithoutVat(product.priceWithVat, product.vat) + Number.EPSILON) * 100) / 100,
  fullPrice: product.priceWithVat,
  quantity: product.count,
  variantName: product.variant,
  stockAvailability: isProductAvailable(product),
  group: EItemGroup.DISCOVERY_BOX,
  cartType: ECartType.Cart,
  primaryCategories: product.primaryCategories,
  annotation: product.annotation,
  additionalVariantInfo: product.additionalVariantInfo,
});
